import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import * as moment from 'moment';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { itLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { ValidatorsManager } from 'src/app/model/ValidatorsManager';
import { AppService } from 'src/app/service/app.service';
import { UserService } from 'src/app/service/user-service.service';
import { capitalize, invalidField } from 'src/app/utils/utils';
import { endpoints } from 'src/endpoint/endpoints';
import { gender } from '../../administration-panel/domain/gender.enum';
import { Patient } from '../model/patient';
import { PazientiService } from '../service/pazienti.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { Observation } from 'src/app/model/Observation';
import { CanComponentDeactivate } from 'src/app/unsaved-changes.guard';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-scheda-paziente',
  templateUrl: './scheda-paziente.component.html',
  styleUrls: ['./scheda-paziente.component.scss']
})

export class SchedaPazienteComponent implements OnInit, CanComponentDeactivate {

  medici; // Lista dei medici a cui possono essere assegnati i pazienti
  mediciSelezionati; // Lista dei medici a cui verrà assegnato il paziente
  defaultLabelListaMedici = 'Selezionare almeno un medico';
  emptyFilterMessageListaMedici = 'Nessun medico trovato';

  patient = {} as Patient;

  patientForm: FormGroup;

  showSpan: boolean = false;

  datePickerConf = { isAnimated: true, adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' };

  locale = 'it';

  gender = gender;

  aggiornamento;

  nomeUtente;

  acceptance;

  password;

  org;

  validatorsManager: ValidatorsManager = new ValidatorsManager();

  @Output() patientId;

  @Input() id;

  @Output() update: EventEmitter<any> = new EventEmitter();

  typeListView;

  // flag per gestire se il form serve a modificare oppure ad inserire un nuovo paziente
  isNew = false;

  // Variabili per il reset password
  confermaModalRef: BsModalRef;
  showModal = false;
  showResetPsw: boolean = true;

  //informazioni per il diabete
  familiaritaDiabeteOptions: SelectItem[];
  showFormDiabete = true;
  diabetesObs = new Array<Observation>();
  categoriaDiabeteOptions: any[];
  durataDiabeteOptions: SelectItem[];
  estensioni = [];
  isTuttiSelezionati = false;
  isTuttiSelezionati2 = false;
  nessunSelezionato = true;
  listaInclusione1 = [];
  listaInclusione2 = [];
  listaEsclusione = [];

  //Genere
  genereOptions = [{ label: 'Maschio', value: gender.MALE }, { label: 'Femmina', value: gender.FEMALE }, { label: 'Altro', value: gender.OTHER }, { label: 'Sconosciuto', value: gender.UNKNOW }]
  centerOptions = [
    { label: 'CMC', value: 'cmc'},
    { label: 'GDC', value: 'gdc'}
  ];
  //Centri
  // centerOptions = [
  //   { label: 'CMC', value: 'c01' },
  //   { label: 'CAPODICHINO', value: 'c02' },
  //   { label: 'CEDISAN', value: 'c03' },
  //   { label: 'CEPIDIAL', value: 'c04' },
  //   { label: 'BETADIAL', value: 'c05' },
  //   { label: 'CNP', value: 'c06' },
  //   { label: 'VESUVIANA', value: 'c07' },
  //   { label: 'DIAL3', value: 'c08' },
  //   { label: 'DIALCAST', value: 'c09' },
  //   { label: 'DIALGEST', value: 'c10' },
  //   { label: 'EMODIAL', value: 'c11' },
  //   { label: 'EURODIAL', value: 'c12' },
  //   { label: 'GDC', value: 'c13' },
  //   { label: 'GSE', value: 'c14' },
  //   { label: 'PROCIDA', value: 'c15' },
  //   { label: 'CMM', value: 'c16' },
  //   { label: 'DIAM', value: 'c17' },
  //   { label: 'IATREION', value: 'c18' },
  //   { label: 'LUDIAL', value: 'c19' },
  //   { label: 'NEFROTRADING', value: 'c20' },
  //   { label: 'NEFROTRADINGNOC', value: 'c21' },
  //   { label: 'SODAV', value: 'c22' },
  //   { label: 'VSA', value: 'c23' },
  //   { label: 'EUR', value: 'c24' },
  //   { label: 'COLLEFERRO', value: 'c25' },
  //   { label: 'SATURNIA', value: 'c26' },
  //   { label: 'EURONEFRO', value: 'c27' },
  //   { label: 'MSC', value: 'c28' },
  //   { label: 'RHA', value: 'c29' },
  //   { label: 'GERAMED', value: 'c30' },
  //   { label: 'STABIA', value: 'c31' },
  //   { label: 'OPLONTI', value: 'c32' },
  //   { label: 'NOLA', value: 'c33' },
  //   { label: 'IRPINO', value: 'c34' },
  //   { label: 'LID', value: 'c35' },
  //   { label: 'NOCERA', value: 'c36' },
  //   { label: 'CMCDIAB', value: 'c37' },
  //   { label: 'DIALNEFRO', value: 'c38' },
  // ];

  //<Small>RedErrorMessage
  errorMessage = {
    centerName: invalidField('empty', 'Centro'),
    id: invalidField('empty', 'CI'),
    age: invalidField('empty', 'Età'),
    gender: invalidField('dropdown', 'Genere'),
    informedConsent: invalidField('check') + 'il consenso informato.',
    acceptanceDate: invalidField('date', 'di accettazione'),
    familiarityDiabetes: invalidField('dropdown', 'Familiarità del diabete'),
    diabetesDuration: invalidField('dropdown', 'Durata diabete'),
    patientCategory: invalidField('dropdown', 'Categoria paziente'),

  };

  criteriInclusioneTipo1 = [
    {
      value: "Appartenenza a Classe NHYA I-II",
      selected: false,
    },
    {
      value: "Ipertrofia ventricolare sinistra documentata da un precedente elettrocardiogramma",
      selected: false,
    },
    {
      value: "Presenza di fatica/modesta dispnea per piccoli sforzi come salire una rampa di 11 scalini o percorrere una distanza di 150 metri in modesta salita",
      selected: false,
    },
    {
      value: "Ecocardiografia (eseguite non oltre 3 mesi prima dell'arruolamento) indicativa di una Frazione di Eiezione compresa tra 40 e 50%",
      selected: false,
    },
  ]

  criteriInclusioneTipo2 = [
    {
      value: "Diabete mellito tipo 2",
      selected: false,

    },
    {
      value: "Appartenenza a Classe NHYA I-II",
      selected: false,

    },
    {
      value: "Presenza di fatica/modesta dispnea per piccoli sforzi come salire una rampa di 11 scalini o percorrere una distanza di 150 metri in modesta salita",
      selected: false,

    },
    {
      value: "Ipertrofia ventricolare sinistra documentata da un precedente elettrocardiogramma",
      selected: false,

    },
    {
      value: "Ecocardiografia (eseguite non oltre 3 mesi prima dell'arruolamento) indicativa di una Frazione di Eiezione compresa tra 40 e 50%",
      selected: false,

    },
  ]

  criteriEsclusione = [
    {
      value: "Malattie oncologiche in atto",
      selected: false,
    },
    {
      value: "Gravidanza",
      selected: false,
    },
    {
      value: "Severe comorbidità invalidanti",
      selected: false,
    },
    {
      value: "Deficit cognitivo-comportamentali tali da impedire un'adesione consapevole al protocollo di studio",
      selected: false,
    },
    {
      value: "Incapacità di comprendere e sottoscrivere il consenso informato",
      selected: false,
    },
  ];

  formCriteriInclusione;
  criteriDaUsare = [];
  criteriDiEsclusione = [];
  formCriteriDiEsclusione;

  toolTipInformedConsent = "Spuntando questa casella si accettano: informativa, consenso al prelievo e all'analisi genetica.";
  toolTipInclusionCriteria = "È necessario includere tutti i criteri di inclusione per poter procedere.";
  toolTipExclusionCriteria = "È necessario escludere tutti i criteri di esclusione per poter procedere.";
  toolTipControllo = "Spuntare per indicare che il paziente è di controllo.";

  showCredenziali = false;

  items: MenuItem[] = [];

  categorieDiabete = [
    { label: 'Diabetico iperteso', value: 'diabetic-hypertensive' },
    { label: 'Diabetico non iperteso', value: 'diabetic-not-hypertensive' },
    { label: 'Dializzato', value: 'dialysis' },
    { label: 'Predialitico', value: 'predialitic' },
    { label: 'Dialitico', value: 'dialitic' }
  ];

  constructor(private fb: FormBuilder, private toastr: ToastrService, private http: HttpClient, private localeService: BsLocaleService,
    private datePipe: DatePipe, private pazientiService: PazientiService, private userService: UserService, private route: ActivatedRoute,
    private appServ: AppService, private modalService: BsModalService) {
    this.update.emit(this.update);
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.pazientiService.setPatientId(this.id);
    this.getPatient();
    this.typeListView = this.appServ.getTypeViewList();
    this.aggiornamento = false;
    itLocale.invalidDate = 'Data non valida';
    defineLocale(this.locale, itLocale);
    this.localeService.use(this.locale);

    if (!this.id) {
      this.buildForm(this.patient);
      this.getAllAvailableUsers();
    }
    this.org = this.userService.getCurrentOrganization();
    if (this.org === 'VIVISOL' || this.org === 'AQUA') {
      this.org = 'NEMO';
    }

    const inputElement = document.getElementById('acceptance');

    if (inputElement) {
      inputElement.addEventListener('keydown', (event: KeyboardEvent) => {
        event.preventDefault();
      });
    }
    this.getCredenziali();
  }

  canViewListaAssegna() {
    return this.userService.isAdmin() || this.userService.isSuperAdmin() || this.userService.isOperatore() || this.userService.isGestoreCentraleOperativa();
  }

  getAllAvailableUsers() {
    this.http.get(endpoints.getUsers).toPromise().then((resp: any) => {
      if (resp) {
        let ms = [];
        ms = resp.object.filter((elem) =>
          elem.referenceId !== 'null'
          && (this.userService.isMedico(elem) || this.userService.isOperatoreSanitario(elem))
          && elem.organization.organization === this.userService.getCurrentOrganization());
        this.medici = new Array();
        ms.forEach(medico => {
          // tslint:disable-next-line: max-line-length
          this.medici.push({ value: { value: medico.referenceId, nome: medico.nome, cognome: medico.cognome, username: medico.username }, nome: medico.nome, cognome: medico.cognome, username: medico.username });
        });
        this.mediciSelezionati = new Array();
        if (this.patient.generalPractitioner) {
          this.patient.generalPractitioner.forEach(reference => {
            const el = this.medici.find(m => m.value.value === reference.reference);
            if (el) {
              this.mediciSelezionati.push(el.value);
            }
          });
        } else {
          if (this.userService.isMedico()) {
            const medico = this.medici.find(m => m.value.value === this.userService.getUser().referenceId);
            this.mediciSelezionati.push(medico.value);
          }
        }
        // Aggiorno il widget
        this.patientForm.get('mediciSelezionati').setValue(this.mediciSelezionati);
      } else {
        this.toastr.error('Errore nel recuperare la lista di medici');
        console.error('Errore nel recuperare la lista dei medici');
      }
    }).catch(err => {
      this.toastr.error('Errore nel recuperare la lista di medici');
      if (err.status == 403) {
        this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
        return;
      }
      console.error('Errore nel recuperare la lista dei medici, errore: ', err);
    });
  }

  getPatient() {
    if (this.id) {
      this.http.get(endpoints.getPatientByPatientId + this.id).toPromise().then((resp: any) => {
        if (resp && resp.success == "1") {
          this.pazientiService.setPatient(resp.message);
          this.mapPatientObject(resp.message);
          this.buildForm(this.patient);
          this.getInformazioniDiabete();
          this.estensioni = resp.message.extension;
          this.patientForm.get('identifier').disable();
          this.patientForm.get('centerName').disable();
          resp.message.extension.find(elem => {
            if (elem.url && elem.url === 'http://riatlas.it/extensions#firstpassword') {
              if (elem.valueString) {
                this.password = elem.valueString;
              }
            }
          });
          this.getAllAvailableUsers();
        }
      }).catch(err => {
        console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
        this.toastr.error('Errore nel recupero del Paziente');
      });
    } else {
      this.isNew = true;
      this.getSanitizedPhoto();
      return this.patient;
    }
  }

  findUserByReference(reference) {
    let toReturn = null;
    this.medici.forEach(u => {
      if (u.value === reference) {
        toReturn = u;
      }
    });
    return toReturn;
  }

  isRequired(campo) {
    return this.validatorsManager.isRequired(campo);
  }

  buildForm(patientIn) {
    this.buildFormDiabete();

    // Popolo la lista di campi obbligatori
    // Usare il formControlName
    this.validatorsManager.addCampoObbligatorio("centerName");
    this.validatorsManager.addCampoObbligatorio("identifier");
    this.validatorsManager.addCampoObbligatorio("acceptance");
    this.validatorsManager.addCampoObbligatorio('familiaritaDiabete');
    this.validatorsManager.addCampoObbligatorio('categoriaDiabete');
    this.validatorsManager.addCampoObbligatorio('durataDiabete');
    this.validatorsManager.addCampoObbligatorio("age");
    this.validatorsManager.addCampoObbligatorio("gender");

    // Aggiungo i Validators dinamicamente
    const validators: Array<Array<any>> = new Array();
    validators['acceptance'] = [
      (control: FormControl) => {
        const isValid = moment(control.value, 'DD/MM/YYYY', true).isValid();
        return isValid ? null : { 'Data non valida': true };
      }
    ];



    // this.validatorsManager.addValidatorByFormControlName('email', Validators.pattern(/^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4}|museum)$/));
    // this.validatorsManager.addValidatorByFormControlName('fiscal_code', Validators.pattern('^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$'));
    // this.validatorsManager.addValidatorByFormControlName('name', Validators.pattern("[^*]*$"));
    // this.validatorsManager.addValidatorByFormControlName('surname', Validators.pattern("[^*]*$"));
    // this.validatorsManager.addValidatorByFormControlName('tel', Validators.pattern("[+]?[0-9]*$"));
    // this.validatorsManager.addValidatorByFormControlName('eta', Validators.pattern("[0-9]*"));

    if (!this.userService.isMedico()) {
      this.validatorsManager.addCampoObbligatorio('mediciSelezionati');
    }

    this.patientForm = this.fb.group({
      // name: [patientIn.name],
      // surname: [patientIn.surname],
      centerName: [patientIn.centerCode],
      identifier: [this.getIdWithoutCenter(patientIn.identifier, patientIn.centerCode)],
      age: [patientIn.age],
      // fiscal_code: [patientIn.fiscal_code],
      // email: [patientIn.email],
      // birthDate: [patientIn.birthDate],
      // tel: [patientIn.tel],
      // city: [patientIn.city],
      gender: [patientIn.gender],
      acceptance: [patientIn.acceptance, validators['acceptance'] !== undefined ? validators['acceptance'] : []],
      // photo: [patientIn.photo],
      mediciSelezionati: [''],
      familiaritaDiabete: [''],
      categoriaDiabete: [''],
      durataDiabete: [''],
      consenso: [false],
      // informativa: [false],
      // prelievo: [false],
      // analisigenetica: [false],
      // accountMobileApp: (patientIn.identifier ? environment.company + patientIn.identifier : ''),
      // passwordMobileApp: (patientIn.identifier ? environment.company + patientIn.identifier : ''),
      isControl: [patientIn.isControl],
      etichettaI: [patientIn.etichettaI],
      etichettaII: [patientIn.etichettaII],
      etichettaIII: [patientIn.etichettaIII],
    }, { validators: this.ValidateDate.bind(this) });

    // this.patientForm.get('accountMobileApp').disable();
    // this.patientForm.get('passwordMobileApp').disable();
    if (!this.checkModify()) {
      this.patientForm.disable();
    }
    if (this.id) {
      this.patientForm.get('identifier').disable();
      // this.patientForm.get('isControl').disable();
    }
    // Setto i vari validators
    this.validatorsManager.form = this.patientForm;
    this.validatorsManager.aggiungiValidatorObbligatori();
    this.validatorsManager.addValidatorByFormControlName("consenso", Validators.requiredTrue);
    // this.validatorsManager.addValidatorByFormControlName("informativa", Validators.requiredTrue);
    // this.validatorsManager.addValidatorByFormControlName("prelievo", Validators.requiredTrue);
    // this.validatorsManager.addValidatorByFormControlName("analisigenetica", Validators.requiredTrue);
    this.validatorsManager.setAllValidatorsToForm();

  }

  checkModify() {
    if (this.isNew) {
      return this.userService.checkOnlyPermission('Anagrafica pazienti', 'insert');
    } else {
      return this.userService.checkPermission('Anagrafica pazienti', 'modify', this.patient);
    }
  }

  checkEmptyField() {
    return this.validatorsManager.campiObbligatori.find(req => {
      const field = this.patientForm.get(req).value;
      if (field == null || field === "") {
        this.toastr.warning('Compilare tutti i campi obbligatori');
      }
    });
  }

  confirmSalva() {
    if (!this.id) {
      this.patientForm.controls["identifier"].patchValue(this.patient.identificativo);
    }
    if (this.patientForm.invalid) {
      this.toastr.warning("Non sono stati compilati tutti i campi obbligatori del paziente.");
      this.patientForm.markAllAsTouched();
      return;
    }

    // Nel caso di una modifica non mostro il popup per la conferma dei criteri di esclusione
    if (this.id) {
      return this.salva();
    }

    let messageToShow = "Proseguendo si conferma che il paziente soddisfa i criteri di inclusione e di esclusione come da protocollo. Continuare?";
    if (this.patientForm.get('categoriaDiabete').value == 'control') {
      messageToShow = "Proseguendo si conferma che il paziente appartiene alla categoria \"CONTROLLO\". Continuare?";
    }

    this.confermaModalRef = this.modalService.show(ConfirmModalComponent, { initialState: { message: messageToShow } });
    const newSubscriber = this.modalService.onHide.subscribe(r => {
      newSubscriber.unsubscribe();
      const res = this.confermaModalRef.content.result;
      if (res) {
        this.salva();
      }
    });
  }

  resetFieldsAfterSave() {
    this.patientForm.patchValue({ centerName: '', identifier: '', age: '', gender: '', etichettaI: '' });
    this.patientForm.get('centerName').markAsPristine();
    this.patientForm.get('identifier').markAsPristine();
    this.patientForm.get('age').markAsPristine();
    this.patientForm.get('gender').markAsPristine();
    this.patientForm.get('etichettaI').markAsPristine();

    this.patientForm.get('centerName').markAsUntouched();
    this.patientForm.get('identifier').markAsUntouched();
    this.patientForm.get('age').markAsUntouched();
    this.patientForm.get('gender').markAsUntouched();
    this.patientForm.get('etichettaI').markAsUntouched();

    this.patientForm.markAsPristine();
  }

  salva() {

    // if (this.formCriteriInclusione.invalid) {
    //   this.toastr.warning("È necessario includere tutti i criteri di inclusione per poter procedere.");
    //   this.formCriteriInclusione.markAllAsTouched();
    //   return;
    // }

    // if (this.formCriteriDiEsclusione.invalid) {
    //   this.toastr.warning("È necessario escludere tutti i criteri di esclusione per poter procedere.");
    //   this.formCriteriDiEsclusione.markAllAsTouched();
    //   return;
    // }

    this.listaEsclusione = [];
    for (let index = 0; index < this.criteriDiEsclusione.length; index++) {
      if (this.formCriteriDiEsclusione.get("" + index).value == true) {
        this.listaEsclusione.push(this.criteriDiEsclusione[index].value);
      }
    }

    let listaInclusione = [];
    for (let index = 0; index < this.criteriDaUsare.length; index++) {
      if (this.formCriteriInclusione.get("" + index).value == true) {
        listaInclusione.push(this.criteriDaUsare[index].value);
      }
    }

    // this.criteriEsclusione.forEach((criterio) => {
    //   this.listaEsclusione.push(criterio.value);
    // });
    let pat: any = {
      patient: this.patientForm.getRawValue(),
    }
    const center = this.centerOptions.find(option => option.value === this.patientForm.get('centerName').value).label;

    pat.patient.identifier = this.patientForm.get('identifier').value;
    pat.patient.centerName = center;
    pat.patient.centerCode = this.centerOptions.find(option => option.value === this.patientForm.get('centerName').value).value;

    let catDiab = this.patientForm.getRawValue()['categoriaDiabete'];
    pat.categoriaDiabete = this.categorieDiabete.find(x => x.label == catDiab || x.value == catDiab)?.value ?? undefined;

    pat.criteriEsclusione = this.listaEsclusione;
    pat.criteriDiInclusione = listaInclusione;
    this.patientForm.markAllAsTouched();

    if (this.patientForm.invalid) {
      this.checkEmptyField();
      return;
    }

    let medici = Array();
    this.patientForm.get("mediciSelezionati").value.forEach(medico => {
      if (undefined === medico.value.value) {
        medico.value = { value: medico.value };
      }
      medici.push(medico.value);
    });
    if (medici.length < 1) {
      this.toastr.warning("Bisogna selezionare almeno un medico.");
      return;
    }
    pat.patient.mediciSelezionati = medici;
    pat.patient.acceptance = this.adattaData(pat.patient.acceptance);
    // pat.birthDate = this.adattaData(pat.birthDate);
    // pat.photo = this.patient.photo.replace('data:image/png;base64,', '');
    // pat.photo = pat.photo.replace('data:image/jpg;base64,', '');
    // pat.photo = pat.photo.replace('data:image/jpeg;base64,', '');

    if (this.userService.isSuperAdmin()) {
      (pat as any).organization = this.userService.getCurrentOrganization();
    }
    pat.patient.identifier = pat.patient.identifier.replaceAll(' ', '');

    if (pat.patient.isControl == undefined || pat.patient.isControl == null) {
      pat.patient.isControl = false;
    }

    if (!this.id) {
      this.http.post(endpoints.addPatient, pat).toPromise().then((resp: any) => {
        if (resp) {
          if (resp.success === '1') {
            // this.selected = resp.object;
            this.patientId = resp.message;
            this.toastr.success('Paziente salvato correttamente');
            this.resetFieldsAfterSave();
          } else {
            console.error(resp.message)
            if (resp.message.length > 0) {
              this.toastr.error(resp.message);
            } else {
              this.toastr.error("Impossibile creare il nuovo paziente.");
            }
          }
        }
      }).catch(err => {
        console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
        this.toastr.error('Errore nel salvataggio del paziente.');
      });
    } else {
      pat.patient.patientID = this.id;
      this.http.post(endpoints.updatePatient, pat).toPromise().then((resp: any) => {
        if (resp) {
          if (resp.success === '1') {
            // this.selected = resp.object;
            this.toastr.success('Paziente modificato correttamente');
            this.updatePazienteTab();
          } else {
            console.error(resp.message);
            if (resp.message.length > 0) {
              this.toastr.error(resp.message);
            } else {
              this.toastr.error("Impossibile salvare le modifiche apportate al paziente.");
            }
          }
        }
      }).catch(err => {
        console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
        this.toastr.error('Errore nel salvataggio del paziente.');
      });
    }
  }

  adattaData(date): any {
    if (typeof date === 'string') {
      const dateParts = date.split('/');
      // tslint:disable-next-line: radix
      const dateToTrans = new Date(Number.parseInt(dateParts[2]), Number.parseInt(dateParts[1]) - 1, Number.parseInt(dateParts[0]));
      return this.datePipe.transform(dateToTrans, 'yyyy-MM-dd');
    } else {
      return this.datePipe.transform(date, 'yyyy-MM-dd');
    }

  }

  adattaDataSet(date: string): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy');
  }

  getSanitizedPhoto() {
    if (this.patient.photo) {
      let prefix = '';
      if (!this.patient.photo.includes('data:image/')) {
        prefix = 'data:image/png;base64,';
      }
      this.patient.photo = prefix + this.patient.photo;
    } else {
      this.getBase64ImageFromUrl('./assets/img/patient.png')
        .then(result => {
          this.patient.photo = result as string;
          this.patient.photo = this.patient.photo.replace(' charset=utf-8;', '');
        })
        .catch(err => console.error(err));
    }
  }

  changeListener($event): void {
    this.readURL($event.target);
  }

  readURL(input) {
    const th = this;
    if (input.files && input.files[0]) {
      // tslint:disable-next-line: prefer-const
      let reader = new FileReader();
      reader.onload = (e) => {
        // $('#imagePreview').css('background-image', this.getSanitizedPhoto(reader.result));
        $('#imagePreview').hide();
        $('#imagePreview').fadeIn(650);
        th.patient.photo = reader.result as string;
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  mapPatientObject(pat: any) {
    this.patient.gender = capitalize(pat.gender);

    // tslint:disable-next-line: forin
    for (const identifier of pat.identifier) {
      switch (identifier.use) {
        case 'official':
          if (identifier.value) {
            this.patient.fiscal_code = identifier.value;
          }
          break;
        case 'usual':
          this.patient.identifier = identifier.value;
          break;
        case 'secondary':
          this.patient.centerCode = identifier.value;
          break;
        default:
          break;
      }
    }

    this.patient.identificativo = (pat.name.find(identifierCode => identifierCode.use === "usual" && identifierCode.given.length > 0)?.given[0]) ?? "";

    this.patient.name = this.pazientiService.getPatientNameOrEmpty();

    this.patient.surname = this.pazientiService.getPatientSurnameOrEmpty();

    this.patient.generalPractitioner = pat.generalPractitioner;

    this.patient.age = this.pazientiService.getAgeFromFhirPatient(pat);

    if (pat.extension) {
      const accept = pat.extension.find(elem => {
        if (elem.url && (elem.url === 'http://riatlas.it/extensions#informedconsentacceptance')) {
          if (elem.valueDateTime) {
            elem.valueDateTime = this.adattaDataSet(elem.valueDateTime);
          } else {
            elem.valueDateTime = new Date();
          }
          return elem.valueDateTime;
        }
      });
      if (accept !== undefined) {
        this.patient.acceptance = accept.valueDateTime;
      }

      // Recupero l'estensione che indica se è un paziente di controllo
      this.patient.isControl = this.pazientiService.getIsControlPatient(pat);
    }
    //this.acceptance = this.pazientiService.getAcceptanceFromFhirPatient(pat) != undefined ? this.adattaDataSet(addPaddingToArray(this.pazientiService.getAcceptanceFromFhirPatient(pat).toString().split("-")).join("/")) : '';

    // Recupero l'etichetta, se c'è
    let etichette = this.pazientiService.getAllLabels(pat);
    this.patient.etichettaI = etichette[0] ?? '';
    this.patient.etichettaII = etichette[1] ?? '';
    this.patient.etichettaIII = etichette[2] ?? '';
  }

  onChangeDate(event: any) {
    if (this.patientForm.get('acceptance').value == undefined || this.patientForm.get('acceptance').value == 'Invalid Date') {
      this.patientForm.get('acceptance').reset();

    }
  }

  updatePazienteTab() {
    this.aggiornamento = !this.aggiornamento;
    this.update.emit(this.update);
    this.patientForm.markAsPristine();
  }


  ValidateDate(control: AbstractControl) {
    if (control.get('birthDate') && control.get('birthDate').value && !moment(control.get('birthDate').value, 'DD/MM/YYYY', true).isValid()) {
      this.toastr.error('Data non valida.');
    }
  }


  async getBase64ImageFromUrl(imageUrl) {
    const res = await fetch(imageUrl);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }

  isInDetail() {
    if (this.id) {
      return true;
    } else {
      return false;
    }
  }

  getCredenziali() {
    if (this.id) {
      this.http.get(endpoints.haveActiveMonitoringPlan + '' + this.id).toPromise().then(resp => {
        if (resp) {
          this.http.get(endpoints.userbyreferenceid + '?referenceid=Patient/' + this.id).subscribe((resp: any) => {
            if (resp) {
              if (resp.status === 'OK') {
                this.nomeUtente = resp.object.username;
                this.showCredenziali = true;
              } else {
                this.showCredenziali = false;
                this.toastr.error('Errore nel retrive dell\'username');
              }
            }
          }, err => {
            this.showCredenziali = false;
            console.error(err);
            if (err.status == 403) {
              this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
              return;
            }
          });
        }
      }).catch(error => {
        this.showCredenziali = false;
        this.toastr.error("Errore nel recupero delle credenziali della Mobile App.");
      });
    }
  }

  confirmReset() {
    if (!this.userService.checkPermission('Anagrafica pazienti', 'modify', this.patient)) {
      this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
      return;
    }
    const initialState = { message: 'La password di questo utente verrà generata nuovamente, procedere nel reset della password?' };
    this.confermaModalRef = this.modalService.show(ConfirmModalComponent, { initialState });
    const newSubscriber = this.modalService.onHide.subscribe(r => {
      newSubscriber.unsubscribe();
      const res = this.confermaModalRef.content.result;
      this.patientId = this.id;
      if (res) {
        if (this.patientId != null) {
          this.http.get(endpoints.passwordReset + this.patientId, { responseType: 'text' }).toPromise().then((resp: any) => {
            this.password = resp;
            this.showModal = true;
            // this.formAmmissione.patchValue({ passwordMobileApp: this.password });
          }).catch((err: any) => {
            if (err.status == 403) {
              this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
              return;
            }
            this.toastr.error('Errore nel reset della password');
          });
        } else {
          this.toastr.error('Nessun Paziente selezionato, riprovare');
        }
      } else {
        this.toastr.info('Azione annullata.');
      }
    });
  }

  buildFormDiabete(obs = new Array<Observation>()) {
    let find = obs.find(x => x.code.coding[0].code == 'diabetesFamily');
    let familiarita: any = find ? find.valueString ?? "" : "";
    find = obs.find(x => x.code.coding[0].code == 'diabetesCategory');
    find = obs.find(x => x.code.coding[0].code == 'diabetesDuration');
    let duration: any = find ? find.valueString ?? "" : "";

    this.familiaritaDiabeteOptions = [];
    this.familiaritaDiabeteOptions.push({ label: 'Sì', value: 'typeI' });
    this.familiaritaDiabeteOptions.push({ label: 'No', value: 'typeII' });
    this.familiaritaDiabeteOptions.push({ label: 'Non lo so', value: 'gestational' });

    this.items = [];
    this.items = [
      { label: 'Diabetico iperteso', command: () => this.setDiabetesCategory('diabetic-hypertensive') },
      { label: 'Diabetico non iperteso', command: () => this.setDiabetesCategory('diabetic-not-hypertensive') },
      {
        label: 'Dializzato',
        items: [
          { label: 'Predialitico', command: () => this.setDiabetesCategory('predialitic') },
          { label: 'Dialitico', command: () => this.setDiabetesCategory('dialitic') }
        ]
      }
    ]

    this.durataDiabeteOptions = [];
    this.durataDiabeteOptions.push({ label: '1 o < 1', value: '1 o < 1' });
    this.durataDiabeteOptions.push({ label: 'tra 1 e 5', value: 'tra 1 e 5' });
    this.durataDiabeteOptions.push({ label: '> 5 e ≤ 10', value: '> 5 e ≤ 10' });
    this.durataDiabeteOptions.push({ label: '> 10', value: '> 10' });

    familiarita = this.familiaritaDiabeteOptions.find(x => x.value == familiarita);

    duration = this.durataDiabeteOptions.find(x => x.value == duration);
  }

  setDiabetesCategory(value) {
    let f = this.categorieDiabete.find(x => x.value == value || x.label == value);
    if (f) {
      this.patientForm.get('categoriaDiabete').patchValue(f.label);
      this.setListeCriteri();
      this.createFormInclusioneEdEsclusione({ value: f.value });
    }
  }

  createObservation(key) {
    switch (key) {
      case 'diabetesFamily':
        return new Observation('diabetes-extension', 'diabetesFamily', 'Familiarità diabete', null, 'Patient/' + this.patientId, '', null);
      case 'diabetesCategory':
        return new Observation('diabetes-extension', 'diabetesCategory', 'Categoria paziente', null, 'Patient/' + this.patientId, '', null);
      case 'diabetesDuration':
        return new Observation('diabetes-extension', 'diabetesDuration', 'Durata diabete (anni)', null, 'Patient/' + this.patientId, '', null);
    }
  }

  getInformazioniDiabete() {
    this.diabetesObs = new Array<Observation>();
    this.http.get(endpoints.getDiabetesInfoByPatientId + this.id).toPromise().then((resp: any) => {
      if (resp.entry == undefined) {
        resp.entry = new Array<any>();
      }
      resp.entry.forEach(element => {
        this.diabetesObs.push(element.resource);
      });
      this.patientForm.get("familiaritaDiabete").setValue(this.familiaritaDiabeteOptions.find(x => x.value == this.diabetesObs.find(x => x.code.coding[0].code === "diabetesFamily")?.valueString)?.value ?? '');
      this.patientForm.get("durataDiabete").setValue(this.durataDiabeteOptions.find(x => x.value == this.diabetesObs.find(x => x.code.coding[0].code === "diabetesDuration")?.valueString)?.value ?? '');

      let toFind: any = this.diabetesObs.find(x => x.code.coding[0].code === "diabetesCategory");
      if (toFind != undefined) {
        toFind = toFind.valueString;

        this.setDiabetesCategory(toFind);
      }

      this.createFormInclusioneEdEsclusione({ value: this.patientForm.get("categoriaDiabete").value });
      // this.patientForm.get("categoriaDiabete").disable();
      this.patientForm.get("consenso").patchValue(this.id != undefined);
      this.patientForm.get("consenso").disable();
    }).catch(error => {
      console.error("Errore: ", error);
      this.toastr.error("Errore nel caricamento delle informazioni aggiuntive del diabete.");
    });
  }

  setListeCriteri() {
    if (this.patientForm.get('categoriaDiabete').value.includes('diabetic')) {
      this.listaInclusione1 = this.estensioni.filter(elem => elem.url && elem.url === 'http://riatlas.it/extensions#criteriInclusioneDialisiDiabetic');
    } else if (this.patientForm.get('categoriaDiabete').value.includes('dialitic')) {
      this.listaInclusione2 = this.estensioni.filter(elem => elem.url && elem.url === 'http://riatlas.it/extensions#criteriInclusioneDialisiDialysis');
      // } else if (this.patientForm.get('categoriaDiabete').value === 'control') {
      //   this.listaEsclusione = this.estensioni.filter(elem => elem.url && elem.url === 'http://riatlas.it/extensions#criteriEsclusione');;
    }
  }

  createFormInclusioneEdEsclusione(event) {
    let category = event.value;
    category = this.categorieDiabete.find(x => x.value == category || x.label == category);
    category = category.value;
    this.criteriDaUsare = [];
    this.criteriDiEsclusione = [];
    if (category.includes('diabetic')) {
      this.criteriDaUsare = this.criteriInclusioneTipo1;
      this.criteriDiEsclusione = this.criteriEsclusione;
    } else if (category.includes('dialitic') || category.includes('dialysis')) {
      this.criteriDaUsare = this.criteriInclusioneTipo2;
      this.criteriDiEsclusione = this.criteriEsclusione;
    }
    this.formCriteriInclusione = undefined;
    this.formCriteriInclusione = new FormGroup({});
    let index = 0;
    this.criteriDaUsare.forEach(e => {
      this.formCriteriInclusione.addControl("" + index++, new FormControl(true));
    });

    index = 0;
    this.formCriteriDiEsclusione = undefined;
    this.formCriteriDiEsclusione = new FormGroup({});
    this.criteriDiEsclusione.forEach(e => {
      this.formCriteriDiEsclusione.addControl("" + index++, new FormControl(false));
    });

    (this.formCriteriDiEsclusione as FormGroup).disable();
    (this.formCriteriInclusione as FormGroup).disable();

  }

  isDisabledSalvaButton() {
    if (this.patientForm == undefined || this.formCriteriInclusione == undefined || this.formCriteriDiEsclusione == undefined) {
      return false;
    }
    return this.patientForm.invalid || this.formCriteriInclusione.invalid || this.formCriteriDiEsclusione.invalid;
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return !this.patientForm.dirty;
  }

  getIdWithoutCenter(id, centerCode) {
    if (!id || !centerCode) {
      return '';
    }
    const centerName = this.centerOptions.find(option => option.value === centerCode).label;
    const startIndex = id.indexOf(centerName) + centerName.length;
    let id2 = id.substring(startIndex);
    if ((id2 as string).startsWith("_")) {
      id2 = id2.substring(1);
    }
    return id2;
  }

}
